import React, { useEffect, useState } from "react";
import { IInventoryItemArchive } from "../../types/archiveInventory.type";
import { DatePicker, Image, message, Table, Typography } from "antd";
import dayjs from "dayjs";
import { api } from "../../api/api";
import { API } from "../../config/config";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveInventory() {
  const [items, setItems] = useState<IInventoryItemArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await api.get("/archive/inventory-items", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      const { items, total } = response.data;

      setItems(items);
      setTotal(total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение инвентаря.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Фото",
      key: "photoUri",
      dataIndex: "photoUri",
      render: (photoUri: string) => {
        if (!photoUri) return "Нет";
        return (
          <div>
            <Image
              key={photoUri}
              src={`${API}/${photoUri}`}
              width={50}
              height={50}
              preview={{ src: `${API}/${photoUri}` }}
              alt="Фото"
              loading="lazy"
              style={{
                cursor: "pointer",
                borderRadius: 4,
                border: "1px solid #ddd",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Ед.измерения",
      dataIndex: "unitOfMeasurement",
      key: "unitOfMeasurement",
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Добавил",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Последнее обновление",
      dataIndex: "lastUpdate",
      key: "lastUpdate",
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Общая стоимость",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Архив Инвентарь</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={items}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
